var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLostAcessImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 258,
    viewBox: "0 0 258 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.25 119.35H170.1V88.8998C170.1 66.5698 151.83 48.2998 129.5 48.2998C107.17 48.2998 88.8996 66.5698 88.8996 88.8998V119.35H78.7496C73.6746 119.35 68.5996 124.425 68.5996 129.5V200.55C68.5996 205.625 73.6746 210.7 78.7496 210.7H180.25C185.325 210.7 190.4 205.625 190.4 200.55V129.5C190.4 124.425 185.325 119.35 180.25 119.35ZM139.65 190.4H119.35L123.41 168.07C118.335 166.04 114.275 159.95 114.275 154.875C114.275 146.755 121.38 139.65 129.5 139.65C137.62 139.65 144.725 146.755 144.725 154.875C144.725 160.965 141.68 166.04 135.59 168.07L139.65 190.4ZM149.8 119.35H109.2V88.8998C109.2 77.7348 118.335 68.5998 129.5 68.5998C140.665 68.5998 149.8 77.7348 149.8 88.8998V119.35Z",
    fill: "#00214D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 258,
    rx: 129,
    fill: "#00214D",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLostAcessImage);
export default __webpack_public_path__ + "static/media/LostAcessImage.1de4bcb6ba6e8c43df2513a62bb25912.svg";
export { ForwardRef as ReactComponent };